<div class="row mt-4">
  <div class="col-md-12">
    <div class="row mb-3">
      <div class="col-6 mr-auto">
        <h3>Multiple Sub Report</h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>Filter by From</u></label>
        <input type="date" [(ngModel)]="filterable.from" class="form-control" placeholder="From">
      </div>
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>Filter by To</u></label>
        <input type="date" [(ngModel)]="filterable.to" class="form-control" placeholder="To">
      </div>
      <div class="col">
        <label for="gotoShortCode"><u>Goto ShortCode</u></label>
        <ng-select [items]="allShortCodes" bindLabel="scView" placeholder="Goto ShortCode" [(ngModel)]="targetShortCode" class="form-control" (ngModelChange)="gotoTargetShortCode($event)">
        </ng-select>
      </div>
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>Filter by Country</u></label>
        <select [(ngModel)]="filterable.country" class="form-control" placeholder="Country"
          (ngModelChange)="changeCountry($event)">
          <option *ngFor="let country of countryList" [ngValue]="country">{{country.name}}</option>
        </select>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>Filter by Operator</u></label>
        <select [(ngModel)]="filterable.operator" class="form-control" placeholder="Operator"
          (ngModelChange)="changeOperator($event)">
          <option *ngFor="let op of operatorList" [ngValue]="op" >{{op}}</option>
        </select>
      </div>
      <div class="col">
        <label for=""><u>Filter by Source</u></label>
        <select [(ngModel)]="filterable.source" class="form-control" placeholder="Source"
          (ngModelChange)="changeSource($event)">
          <option value=null >-- source --</option>
          <option *ngFor="let source of sourceList" [ngValue]="source">{{source.name}}</option>
        </select>
      </div>
      <div class="col">
        <label for=""><u>Filter by Short Code</u></label>
        <ng-select [items]="shortCodeList" placeholder="Select short code"
          [(ngModel)]="filterable.shortCode" class="form-control"  (clear)="onClear()" (ngModelChange)="changeShortCode($event)">
        </ng-select>
      </div>
      <div class="col align-self-center text-center">
        <input type="checkbox" class="form-check-input" id="currentIsActiveId" [(ngModel)]="filterable.currentIsActive">
        <label class="form-check-label" for="currentIsActiveId">Current Is Active</label>
      </div>
    </div>
  </div>
</div>
<div class="mt-3 mb-2 row">
  <div class="col-2 align-self-center">
    Total Results: {{totalItems}}
  </div>
  <div class="col text-right align-self-end">
    <button class="btn btn-primary btn-sm mr-2" (click)="search()">Search</button>
    <button class="btn btn-success btn-sm mr-2" (click)="export()" *ngIf="!exporting">Export</button>
    <button class="btn btn-success btn-sm mr-2 d-none" id="download" (click)="openModal(viewDownloadUrl)">Open</button>
    <button class="btn btn-success btn-sm mr-2" *ngIf="exporting" disabled>Exporting</button>
  </div>
</div>
<!-- <div class="table-responsive"> -->
<table id="multiSubList" class="table table-striped table-bordered mt-3" style="width:100%">
  <thead class="text-center">
    <tr>
      <th>Sub Times</th>
      <th>The number of subscriber </th>
    </tr>
  </thead>
  <tbody>
    <tr *ngIf="loading">
      <td colspan="5">
        <div class="loader">Loading...</div>
      </td>
    </tr>
    <tr *ngIf="emptyResult">
      <td colspan="5">
        <div class="alert alert-warning">Empty Result...</div>
      </td>
    </tr>
    <tr *ngFor="let multiSub of multiSubReports | keyvalue: returnZero">
      <td class="text-center">{{multiSub.key}}</td>
      <td class="text-center">{{multiSub.value}}</td>
    </tr>
  </tbody>
</table>
<!-- </div> -->

<ng-template #viewDownloadUrl let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="downloadUrl-header">Download URL</h5>
    <button type="button" class="close" (click)="modal.dismiss()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="form-group row">
      <div class="col-12">
        Click to download:
        <a href={{downloadUrl}} target="_blank">
          {{downloadUrl}}
        </a>
      </div>
    </div>
  </div>
</ng-template>
